import type { HelpFile } from '../../types/help'
import { PartiesTestIds } from '../../../testids/PartiesTestIds'

export const partiesHelp: HelpFile = {
  docPage: '/docs/identity/parties',
  texts: {
    [PartiesTestIds.partiesList]:
      'Every party — the real-world actor (person, organisation, AI agent) that identities and accounts attach to.',
    [PartiesTestIds.partyRow]: null,
  },
}
